<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TEAM_ROLE_TYPES } from './store'
import { ROUTES as ACCOUNT_ROUTES } from './router.js'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import TeamRoleTable from './TeamRoleTable'
import TeamRoleEdit from './TeamRoleEdit.vue'

export default {
  name: 'TeamRoleList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': TeamRoleTable,
    'component-edit': TeamRoleEdit,
    'component-detail': TeamRoleEdit
  },
  data () {
    return {
      ACCOUNT_ROUTES,
      title: this.$t('Team Roles'),
      showCommonFilters: false,
      fieldName: 'id',
      searchFields: [
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 6 }
      ],
      rolePerm: 'account_user_list',
      actionEnablePermission: ['account_user_enable'],
      actionDisablePermission: ['account_user_disable']
    }
  },
  computed: {
    ...mapGetters({
      ...TEAM_ROLE_TYPES.GENERIC.account.teamrole.LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.ACCOUNT_ROUTES.TEAM_ROLE_LIST
    },
    canSeeActionSelect () {
      return false
    },
    canAddInstance () {
      return hasPerm('account_user_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: TEAM_ROLE_TYPES.GENERIC.account.teamrole.LIST.MUTATIONS.setSelectedList,
      setSelectAll: TEAM_ROLE_TYPES.GENERIC.account.teamrole.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TEAM_ROLE_TYPES.GENERIC.account.teamrole.LIST.ACTIONS,
      partialUpdate: TEAM_ROLE_TYPES.GENERIC.account.teamrole.DETAIL.ACTIONS.partialUpdate
    }),
    doAction (actionType, fieldName = 'id') {
      if ((this.selectedList.length !== 0 || this.selectAll) && actionType) {
        const idList = this.selectedList.map((instance) => instance[fieldName])
        let counter = 0
        if (actionType === 'enable' || actionType === 'disable') {
          idList.forEach((id) => {
            this.partialUpdate({ id: id, is_active: actionType !== 'disable' }).then(() => {
              if (counter === idList.length - 1) {
                this.getList()
                this.setSelectedList([])
              }
              counter += 1
            })
          })
        } else {
          this.doCustomActions(actionType, idList, counter)
        }
      }
    }
  }
}
</script>
